module.exports = __webpack_public_path__ + "static/img/Csilla_Klenyanszki_Pillarsofhome_nr62.2374ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/07/Csilla_Klenyanszki_Pillarsofhome_nr62.jpg
// module id = p2Mh
// module chunks = 7